import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Conversation } from './useGetConversationById'

export enum ConversationType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

const fetchConversations = async ({ pageParam = '0', type, scope, search }: FetchParams): Promise<PaginatedResponse<Conversation>> => {
  let url = `/conversations?page=${pageParam}`
  if (type) url += `&type=${type}`
  if (scope) url += `&scope=${scope}`
  if (search) url += `&search=${encodeURIComponent(search)}`
  
  const { data } = await api.get<PaginatedResponse<Conversation>>(url)
  return data
}

export const usePaginateConversations = ({ type, scope, search }: { type?: ConversationType, scope?: string, search?: string } = {}) => {
  return usePaginate<Conversation>('conversations', fetchConversations, { type, scope, search })
}

